import { cn } from '../../lib/utils';

const toneMap = {
  blue: 'bg-blue-50 text-blue-700 border-blue-100',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  amber: 'bg-amber-50 text-amber-700 border-amber-100',
  red: 'bg-red-50 text-red-700 border-red-100',
  purple: 'bg-violet-50 text-violet-700 border-violet-100',
  slate: 'bg-slate-50 text-slate-700 border-slate-100'
};

export default function MetricStrip({ metrics = [], columns = 'lg:grid-cols-5' }) {
  return (
    <div className={cn('grid grid-cols-1 gap-3 sm:grid-cols-2', columns)}>
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <div
            key={metric.label}
            className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs font-medium text-slate-500">{metric.label}</div>
                <div className="mt-1 text-2xl font-semibold text-slate-950">{metric.value}</div>
              </div>
              {Icon && (
                <div className={cn('rounded-full border p-2.5', toneMap[metric.tone || 'blue'])}>
                  <Icon className="h-4 w-4" />
                </div>
              )}
            </div>
            {metric.detail && (
              <div className="mt-2 text-xs text-slate-500">{metric.detail}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
